import { render, staticRenderFns } from "./dialer.vue?vue&type=template&id=21cbde51&"
import script from "./dialer.vue?vue&type=script&lang=js&"
export * from "./dialer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialer.vue"
export default component.exports